export default __webpack_public_path__ + "static/media/Scripture of Coronal Skies.e2093a84.jpg";